import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Ruler, ChevronDown } from "lucide-react";
import { fetchServicesSectionPublic } from "./api";
import { ICON_MAP, cotizarUrl } from "./utils";
import { Lightbox } from "./Lightbox";

const ServiceBlockCard = ({ block }) => {
  const [requisitosOpen, setRequisitosOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const Icon = ICON_MAP[block.icono] || ICON_MAP.camera;
  const media = block.media || [];

  return (
    <article className="pp2-service-block" data-testid={`pp2-service-block-${block.id}`}>
      <div className="pp2-service-head">
        <span className="pp2-service-icon"><Icon size={26} /></span>
        <div>
          <h3 className="pp2-service-title">{block.titulo}</h3>
          {block.subtitulo && <p className="pp2-service-subtitle">{block.subtitulo}</p>}
        </div>
      </div>

      {block.texto && <p className="pp2-service-text">{block.texto}</p>}

      {block.puntos?.length > 0 && (
        <ul className="pp2-service-points" data-testid={`pp2-service-points-${block.id}`}>
          {block.puntos.map((p, i) => <li key={i}>{p}</li>)}
        </ul>
      )}

      {media.length > 0 && (
        <div className="pp2-service-gallery" data-testid={`pp2-service-gallery-${block.id}`}>
          {media.map((m, i) => (
            <button
              key={m.id}
              type="button"
              className="pp2-service-media-thumb"
              onClick={() => setLightboxIndex(i)}
              data-testid={`pp2-service-media-${m.id}`}
              aria-label={m.caption || (m.tipo === "video" ? "Ver video" : "Ver foto")}
            >
              {m.tipo === "video" ? (
                <video src={m.url} muted loop autoPlay playsInline />
              ) : (
                <img src={m.url} alt={m.caption || block.titulo} loading="lazy" />
              )}
              {m.caption && <span className="pp2-service-media-caption">{m.caption}</span>}
            </button>
          ))}
        </div>
      )}

      {block.espacio_requerido && (
        <div className="pp2-service-space" data-testid={`pp2-service-space-${block.id}`}>
          <Ruler size={16} />
          <span>Espacio requerido: <strong>{block.espacio_requerido}</strong></span>
        </div>
      )}

      <div className="pp2-service-actions">
        <Link to={cotizarUrl(block.cotizar_target)} className="pp2-cta" data-testid={`pp2-service-cotizar-${block.id}`}>
          Cotizar
        </Link>
      </div>

      {block.requisitos?.length > 0 && (
        <div className="pp2-service-requisitos">
          <button
            type="button"
            className="pp2-service-requisitos-toggle"
            onClick={() => setRequisitosOpen((v) => !v)}
            data-testid={`pp2-service-requisitos-toggle-${block.id}`}
            aria-expanded={requisitosOpen}
          >
            <ChevronDown size={16} className={requisitosOpen ? "pp2-chevron-open" : ""} />
            Requisitos para el montaje
          </button>
          {requisitosOpen && (
            <ul className="pp2-service-requisitos-list" data-testid={`pp2-service-requisitos-list-${block.id}`}>
              {block.requisitos.map((r, i) => <li key={i}>{r}</li>)}
            </ul>
          )}
        </div>
      )}

      {lightboxIndex !== null && (
        <Lightbox mediaList={media} index={lightboxIndex} onClose={() => setLightboxIndex(null)} onNavigate={setLightboxIndex} />
      )}
    </article>
  );
};

export function Pp2ServicesSection() {
  const [section, setSection] = useState(null);

  useEffect(() => {
    fetchServicesSectionPublic()
      .then((res) => setSection(res.data))
      .catch(() => setSection(null));
  }, []);

  if (!section || !section.visible || !section.bloques?.length) return null;

  return (
    <section className="pp2-wrap pp2-services-section" data-testid="pp2-services-section">
      <span className="pp2-services-kicker">DESDE 2014</span>
      <h2 className="pp2-services-title" data-testid="pp2-services-section-title">{section.titulo}</h2>
      <div className="pp2-services-grid">
        {section.bloques.map((b) => <ServiceBlockCard key={b.id} block={b} />)}
      </div>
      <p className="pp2-services-finetext">Fuera de Chihuahua ciudad o en lugares retirados puede aplicar flete.</p>
    </section>
  );
}
